<br>
<div class="container border rounded-3 p-3" style="max-width:400px;">
  <h3>Skapa medlemsmatrikel för</h3>
  <h4><b>{{institution}}</b></h4>
  <hr>
  <form [formGroup]="membermatrixform">
    <div class="d-flex justify-content-start">
      <div>
        <label for="size">Storlek</label>
        <select class="form-control form-control-sm" id="size" formControlName="size" style="width:60px;">
          <option value="A4">A4</option>
          <option value="A6">A6</option>
        </select>
      </div>
      <div class="mx-2">
        <label for="format">Format</label>
        <select class="form-control form-control-sm" id="format" formControlName="format" style="width:70px;">
          <option value="pdf">pdf</option>
          <option value="docx">docx</option>
        </select>
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-start mt-3">
    <button class="btn" type="button" (click)="generateReport()" [disabled]="!membermatrixform.valid">Skapa
      matrikel</button>
    <button class="btn mx-2" (click)="cancel()">Avbryt</button>
    <i *ngIf="showSpinner" class="fa fa-spinner fa-spin" style="font-size:32px;color:#920000;margin-left:20px;"></i>
  </div>
</div>